import { useMutation } from 'react-query';
import spedAssesmentServices from './sped-assessment.services';
import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import { QUERY_SPED_DOCUMENT_DETAIL } from '../sped-documents/sped-documents.hooks';
import { AxiosError } from 'axios';

export function useSpedAssessmentStart() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: spedAssesmentServices.start,
    onSuccess(_, id) {
      notification.success({ message: 'Apuração do documento SPED iniciado' });
      queryChanel({ invalidateQueries: [[QUERY_SPED_DOCUMENT_DETAIL, id]] });
    },
    onError(error: AxiosError) {
      notificationError(error, { description: error?.response?.data?.detail });
    },
  });
}

export function useSpedAssessmentReport() {
  return useMutation({
    mutationFn: spedAssesmentServices.report,
    onSuccess() {
      notification.success({ message: 'Relatório gerado com sucesso' });
    },
    onError(error: AxiosError) {
      notificationError(error, { description: error?.response?.data?.detail });
    },
  });
}

export function useSpedAssessmentConsult() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: spedAssesmentServices.consult,
    onSuccess(_, id) {
      notification.success({ message: 'Consulta da apuração executada' });
      queryChanel({ invalidateQueries: [[QUERY_SPED_DOCUMENT_DETAIL, id]] });
    },
    onError(error: AxiosError) {
      notificationError(error, { description: error?.response?.data?.detail });
    },
  });
}

export function useSpedAssessmentReopen() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: spedAssesmentServices.reopen,
    onSuccess(_, id) {
      notification.success({
        message: 'Solicitado reabertura do documento SPED',
      });
      queryChanel({ invalidateQueries: [[QUERY_SPED_DOCUMENT_DETAIL, id]] });
    },
    onError(error: AxiosError) {
      notificationError(error, { description: error?.response?.data?.detail });
    },
  });
}
